import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {StartComponent} from "./pages/start/start.component";
import {KontaktComponent} from "./pages/kontakt/kontakt.component";
import {ImpressumComponent} from "./pages/impressum/impressum.component";
import {DatenschutzComponent} from "./pages/datenschutz/datenschutz.component";
import {PageComponent} from "./pages/page/page.component";

const routes: Routes = [
  { path: '', component: StartComponent},
  { path: 'walken-und-joggen', component: PageComponent, data: { page_id: 'cloe1vuyg7n5i0buljbmxkw7j' }},
  { path: 'walken-und-joggen/effekt', component: PageComponent, data: { page_id: 'cloe2z8kvubu70bw0h3k8oyz1' }},
  { path: 'walken-und-joggen/anleitung', component: PageComponent, data: { page_id: 'cloe3bku3uauy0awc25vel329' }},
  { path: 'walken-und-joggen/referenzen', component: PageComponent, data: { page_id: 'cloe3djk4u93q0bvyqiw8br1h' }},
  { path: 'kontakt', component: KontaktComponent},
  { path: 'impressum', component: ImpressumComponent},
  { path: 'datenschutz', component: DatenschutzComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    initialNavigation: 'enabledBlocking'
})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
